import { Config } from './types/config';

export const config: Config = {
  aws: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_0FOkQZvxY',
    userPoolWebClientId: '2il6s02ucuk6767l9h9609o140'
  },
  okta: {
    issuer: 'https://gmr.okta.com/oauth2/default',
    clientId: '0oa1b3v2ojpqmxtkt358',
    redirectUri: 'https://dev.d1aupzoxmsgidt.amplifyapp.com/login/callback',
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
  },
  API_BASE_URL: 'https://dev.gmr.eb.produtonics.com/dev/api/v1',
  //API_BASE_URL: 'http://localhost:5000/dev/api/v1',
  ENVIRONMENT: 'development',
};